/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientSymptomHistory from './patient-symptom-history';
import PatientSymptomHistoryDetail from './patient-symptom-history-detail';
import PatientSymptomHistoryUpdate from './patient-symptom-history-update';
import PatientSymptomHistoryDeleteDialog from './patient-symptom-history-delete-dialog';

const PatientSymptomHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientSymptomHistory />} />
    <Route path="new" element={<PatientSymptomHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<PatientSymptomHistoryDetail />} />
      <Route path="edit" element={<PatientSymptomHistoryUpdate />} />
      <Route path="delete" element={<PatientSymptomHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientSymptomHistoryRoutes;
